import { Theme } from "../constants";

export default {
    container: {
        display: 'flex',
        flexDirection: "column",
        maxWidth: '88vw',
        minWidth: '100%',
        justifyContent: 'space-between',
    },
    tableContainer: {
    },
    overflowClip: {
        overflowX: 'clip'
    },
    commonRowContainer: {
        verticalAlign: 'middle',
        textAlign: 'left',
        border: "none",
        padding: "18px 5px"
    },
    checkboxColumnStyles: {
        width: "160px",
    },
    paginationParentContainer: {
        display: 'flex'
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'end',
        alignItems: 'center',
        columnGap: "20px"
    },
    pageNumbers: {
        paddingTop: '12px'
    },
    rowStyle: {

    },
    headerCellContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    headerCellContainerSortable: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        cursor: 'pointer',
        alignItems: 'center'
    },
    headerRowContainer: {
        borderBottom: "1px solid",
        borderColor: "#E4C358",
    },
    tableBodyRowContainer: {
        borderBottom: "0.5px solid",
        borderColor: "#BEBEBE",
    },
    sortIcon: {
        paddingLeft: '4px'
    },
    rowsSelectionContainer: {
        display: "flex",
        // marginRight: "14px"
    },
    rowSelectionDropdownContainer: {
        // width: "50px",
        marginLeft: "8px"
    },
    rowSelectionDropdown: {
        fontSize: "14px",
        caretColor: "transparent",
        cursor: "pointer",
        maxWidth: "73px",
        padding: "0px"
    },
    rowSelectionDropdownIcon: {
        paddingLeft: "0px",
    },
    toggleGroupIcon: {
        
    },
    groupHeaderRow: {
        border: "none",
    },
    groupHeaderContent: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        padding: "20px",
        background: "#ffffff",
    },
    flagCircle: {
        display: "flex",
        width: "15px",
        height: "15px",
        borderRadius: "15px",
    },
    green: {
        background: "#A9CE41",
    },
    red: {
        background: "#C53A3A",
    },
    yellow: {
        background: "#F9C947",
    },
    dataNotFound: {
        textAlign: "center"
    },
    totalRecords:{
        margin: "0px 10px"
    },
    errorTooltip: {
        background: Theme.ERROR_BACKGROUND,
    }
}